import React from 'react';
import { useNavigate, Link } from 'react-router-dom';
import { useMsal } from '@azure/msal-react';
import { FaBars, FaBell, FaQuestionCircle, FaUserShield, FaSignOutAlt, FaBuilding } from 'react-icons/fa';
import './DataPageHeader.css';

const DataPageHeader = ({ selectedOrg, onMobileMenuClick, userRole }) => {
  const navigate = useNavigate();
  const { instance, accounts } = useMsal();

  const displayUserName = accounts.length > 0 ? accounts[0].name : 'Admin User';
  const getInitials = (name) => (name ? name.substring(0, 2).toUpperCase() : 'AD');

  const handleLogout = () => {
    instance.logoutRedirect({ postLogoutRedirectUri: window.location.origin });
  };

  return (
    <>
      <header className="data-page-header">
        <div className="d-flex align-items-center justify-content-between h-100">
          {/* LEFT: Mobile Menu & Org Name */}
          <div className="header-left d-flex align-items-center gap-2">
            <button type="button" className="op-header-menu-btn" onClick={onMobileMenuClick}>
              <FaBars size={15} />
            </button>
            <div className="org-name-display">
              <span className="d-none d-md-block">{selectedOrg ? selectedOrg.name : 'No Organization Selected'}</span>
            </div>
          </div>

          {/* MIDDLE: Logo */}
          <div className="header-center">
            <img src="/op_logo.png" alt="OrientalPay" className="header-logo" />
            <div className="org-name-subtext d-md-none">{selectedOrg ? selectedOrg.name : 'No Organization'}</div>
          </div>

          {/* RIGHT: User Utilities */}
          <div className="header-utils">
            <button className="util-btn" title="Help & Support" onClick={() => navigate('/support')}>
              <FaQuestionCircle size={18} />
            </button>

            <button className="util-btn" title="Notifications">
              <FaBell size={18} />
              <span className="notification-dot"></span>
            </button>

            <div className="dropdown">
              <div className="user-avatar" data-bs-toggle="dropdown" aria-expanded="false" title="Account Settings">
                {getInitials(displayUserName)}
              </div>
              <ul className="dropdown-menu dropdown-menu-end shadow border-0 mt-2 rounded-3">
                <li className="px-3 py-2 border-bottom mb-1">
                  <div className="fw-bold text-dark">{displayUserName}</div>
                  <div className="small text-muted">{selectedOrg ? selectedOrg.name : 'No Organization Selected'}</div>
                </li>
                {userRole === 'admin' && (
                  <li><Link className="dropdown-item py-2" to="/admin"><FaUserShield size={15} /> <span className="me-2">Admin</span></Link></li>
                )}
                {userRole !== 'l1' && userRole !== 'l2' && (
                  <li><Link className="dropdown-item py-2" to="/org-management"><FaBuilding size={15} /> <span className="me-2">Org Management</span></Link></li>
                )}
                <li><hr className="dropdown-divider" /></li>
                <li><button className="dropdown-item py-2 text-danger" onClick={handleLogout}><FaSignOutAlt className="me-2" /> Sign Out</button></li>
              </ul>
            </div>
          </div>

        </div>
      </header>
    </>
  );
};

export default DataPageHeader;